/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { Component } from 'react'
// import 'rc-datepicker/lib/style.css';
// import { DatePicker, DatePickerInput } from 'rc-datepicker';
const opdays = []
const opyears = []
const opMonthNumeric =[]

const date = '' 
const onChange = (jsDate, dateString) => {
  console.log(jsDate, dateString);
}

    for(let i = 1; i < 31; i++){
      opdays.push({'value':i,'label':i})
    }
    for(let m = 1; m <= 12; m++){
      opMonthNumeric.push({'value':m,'label':m})
    }
    for(let yy = 1950; yy <= 2001; yy++){
      opyears.push({'value':yy,'label':yy})
    }

const opMonth = [
  { value: 1 , label: 'Enero' },
  { value: 2 , label: 'Febrero' },
  { value: 3 , label: 'Marzo' },
  { value: 4 , label: 'Abril' },
  { value: 5 , label: 'Mayo' },
  { value: 6 , label: 'Junio' },
  { value: 7 , label: 'Julio' },
  { value: 8 , label: 'Agosto' },
  { value: 9 , label: 'Septiembre' },
  { value: 10 , label: 'Octubre' },
  { value: 11 , label: 'Noviembre' },
  { value: 12 , label: 'Diciembre' }
]


const Calendar = ({props}) => { 

  return (
    <div>
    { props == 'fr' &&
      <div className='form-row-fch'>
          <div className='inputGroup mrg-fecha-nac'>
            <select name="" id="" >
              { opdays.map((value,i) => {
                  return ( <option value={value.value} key={i}>{value.label}</option> )
              })}
            </select>
            <div className="inputLabel"><label>Día</label></div>
          </div>

          <div className='inputGroup mrg-fecha-nac'>
            <select name="" id="" >
              { opMonthNumeric.map((value, i) => {
                  return ( <option value={value.value} key={i}>{value.label}</option> )
              })}
            </select>
            <div className="inputLabel"><label>Mes</label></div>
          </div>

          <div className='inputGroup'>
            <select name="" id="" >
              { opyears.map((value, i) => {
                  return ( <option value={value.value} key={i}>{value.label}</option> )
              })}
            </select>
            <div className="inputLabel"><label>Año</label></div>
          </div>
      </div>
    } 

    {/* {
      props == 'tr' &&
      <div className='form-date-snt'>
        <div className='inputGroup'>
          <DatePickerInput
          onChange={onChange}
          value={date}
          className='date-picker-custom-snt'
          placeholder='Fecha de Nacimiento'
          />          
        </div> 
      </div>   
    } */}
    </div> 
  )
}

export default Calendar;